import { SxProps, Theme } from '@mui/material';

export const buttonWhiteSX: SxProps<Theme> = {
	backgroundColor: '#FFF',
	color: '#2C2C2C',
	textTransform: 'uppercase',
	letterSpacing: '0.5px',
	whiteSpace: 'nowrap',
	boxShadow: 'none',
	'&:hover': {
		backgroundColor: '#F1F1F1',
		color: '#2C2C2C',
		boxShadow: 'none',
	},
};

export const buttonOutlinedWhiteSX: SxProps<Theme> = {
	backgroundColor: 'transparent',
	border: '1px solid #FFF',
	color: '#FFF',
	textTransform: 'uppercase',
	letterSpacing: '0.5px',
	whiteSpace: 'nowrap',
	'&:hover': {
		backgroundColor: '#FFFFFF26',
		borderColor: '#FFF',
		color: '#FFF',
	},
};
